import * as React from "react";
const SvgFiRrBookmarkSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bookmark-slash_svg__a)">
      <path
        fill="#062147"
        d="M23.707 22.293 21 19.586V6c0-2.757-2.243-5-5-5H8c-1.485 0-2.876.66-3.816 1.77L1.707.293A1 1 0 1 0 .292 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M8 3h8c1.654 0 3 1.346 3 3v11.586L5.606 4.192A3 3 0 0 1 8 3m4.239 14.173-4.512 4.954a2.74 2.74 0 0 1-1.995.872c-.34 0-.681-.064-1.011-.195a2.72 2.72 0 0 1-1.722-2.537V9a1 1 0 0 1 2 0v11.267c0 .447.322.623.46.679a.71.71 0 0 0 .8-.178l4.5-4.94a1 1 0 0 1 1.48 1.345"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bookmark-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBookmarkSlash;
